/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StackDateTypeDto {
  PRE_REGISTRATION = 'PreRegistration',
  MEASURED = 'Measured',
  LOADED_INTO_SYSTEM = 'LoadedIntoSystem',
  ASSIGNED_TO_SAWMILL = 'AssignedToSawmill',
  LAST_CHANGED = 'LastChanged',
  INVOICEABLE = 'Invoiceable',
}
